import { UserContact } from "../models/user-contact";

// Provides mapping methods for user contacts.
export class ContactMapper {
	// Maps a user contact API response to a {@link UserContact}.
	// @param contactResponse The API contact to convert.
	// @returns The mapped {@link UserContact}.
	public static mapContact(contactResponse: any) {
		const contact: UserContact = new UserContact();

		contact.id = contactResponse.id
		contact.name = contactResponse.name;
		contact.emailAddress = contactResponse.email;
		contact.phone = contactResponse.phone;

		return contact;
	}
}